/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OAuthLoginCommand = {
    /**
     * OAuth access token
     */
    accessToken: string;
    /**
     * OAuth provider
     */
    oAuthProvider: OAuthLoginCommand.oAuthProvider;
    /**
     * Device identifier. Used for creating a QR code customer card.
     */
    customerDeviceId?: string;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
};
export namespace OAuthLoginCommand {
    /**
     * OAuth provider
     */
    export enum oAuthProvider {
        GOOGLE = 'google',
        FACEBOOK = 'facebook',
    }
}

